import React from "react";
import { useNavigate } from "react-router-dom";

const NoFaultPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .nf-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #fefce8 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .nf-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .nf-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(234, 179, 8, 0.25), rgba(252, 211, 77, 0.12));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .nf-hero {
            grid-template-columns: 1fr;
          }
        }

        .nf-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(234, 179, 8, 0.25);
          color: #854d0e;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .nf-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #eab308;
        }

        .nf-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .nf-subtitle {
          font-size: 15px;
          max-width: 580px;
          color: #374151;
        }

        .nf-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .nf-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .nf-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .nf-btnPrimary,
        .nf-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .nf-btnPrimary {
          background: #eab308;
          color: #0f172a;
          box-shadow: 0 10px 24px rgba(234, 179, 8, 0.4);
        }

        .nf-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(234, 179, 8, 0.55);
        }

        .nf-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .nf-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .nf-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .nf-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .nf-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .nf-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .nf-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .nf-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .nf-flexCol {
          flex: 1 1 260px;
        }

        .nf-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .nf-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .nf-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .nf-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #eab308;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .nf-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .nf-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .nf-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .nf-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TWO-COLUMN GRID SECTION */
        .nf-twoColGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .nf-pillBox {
          padding: 14px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .nf-pillTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .nf-pillText {
          font-size: 13px;
          color: #4b5563;
        }

        /* TIMELINE */
        .nf-timeline {
          display: grid;
          gap: 10px;
          margin-top: 14px;
        }

        .nf-step {
          display: flex;
          gap: 10px;
          align-items: flex-start;
        }

        .nf-stepNumber {
          width: 22px;
          height: 22px;
          border-radius: 999px;
          background: #eab308;
          color: #0f172a;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 700;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .nf-stepBody {
          font-size: 13px;
          color: #111827;
        }

        .nf-stepBody strong {
          display: block;
          margin-bottom: 2px;
        }

        /* BANNER */
        .nf-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .nf-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .nf-banner img {
            height: 270px;
          }
        }

        .nf-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .nf-bannerText {
          color: #fefce8;
          font-size: 15px;
          max-width: 460px;
        }

        .nf-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .nf-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .nf-bannerButtons .primary {
          background: #eab308;
          color: #0f172a;
        }

        .nf-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .nf-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .nf-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .nf-bottomText strong {
          color: #fef9c3;
        }

        .nf-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .nf-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .nf-bottomActions .primary {
          background: #eab308;
          color: #0f172a;
        }

        .nf-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .nf-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="nf-page">
        <div className="nf-inner">
          {/* HERO */}
          <section className="nf-hero">
            <div>
              <div className="nf-tag">
                <span className="nf-tagDot" />
                No-Fault · Auto Injury · Physical Therapy
              </div>
              <h1 className="nf-title">
                After a car accident, no-fault physical therapy can help you move again while the paperwork gets sorted.
              </h1>
              <p className="nf-subtitle">
                No-fault coverage is designed so you can get care—like physical therapy—after a motor vehicle accident
                without waiting for blame to be decided. We focus on your body, while we help you stay organized with the process.
              </p>

              <div className="nf-chips">
                <span className="nf-chip">Whiplash & neck pain</span>
                <span className="nf-chip">Back & shoulder pain</span>
                <span className="nf-chip">Knee, hip, or ankle pain</span>
                <span className="nf-chip">Headache & stiffness</span>
              </div>

              <div className="nf-ctaRow">
                <button
                  className="nf-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a no-fault visit →
                </button>
                <button
                  className="nf-btnSecondary"
                  onClick={() => navigate("/contact")}
                >
                  Ask about no-fault coverage
                </button>
              </div>
            </div>

            <div className="nf-heroImgWrap">
              <img
                src="/content/no-fault-pt/nofault_hero.png"
                alt="Therapist talking with patient about no-fault physical therapy after an accident"
                className="nf-heroImg"
              />
            </div>
          </section>

          {/* WHAT IS NO-FAULT */}
          <section className="nf-stripe">
            <div className="nf-flexRow">
              <div className="nf-flexCol">
                <div className="nf-sectionTitle">What is no-fault, and how does it relate to PT?</div>
                <p className="nf-sectionSubtitle">
                  In many places, no-fault (personal injury protection) coverage is a type of insurance that can help
                  pay for medical care—like physical therapy—after a car accident, no matter who was at fault.
                  Exact rules depend on your policy and local laws, but the goal is similar: don&apos;t delay care while liability is sorted out.
                </p>

                <ul className="nf-list">
                  <li>
                    <span className="nf-bullet" />
                    <span>
                      You were in a car accident and now have pain, stiffness, or limited motion.
                    </span>
                  </li>
                  <li>
                    <span className="nf-bullet" />
                    <span>
                      Your doctor, urgent care, or attorney recommended physical therapy under no-fault coverage.
                    </span>
                  </li>
                  <li>
                    <span className="nf-bullet" />
                    <span>
                      You want to understand how PT can help while staying within what your policy allows.
                    </span>
                  </li>
                </ul>

                <div className="nf-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="nf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule an evaluation →
                  </button>
                </div>
              </div>

              <div className="nf-flexCol">
                <img
                  src="/content/no-fault-pt/nofault_paperwork.png"
                  alt="Staff member reviewing no-fault paperwork with patient"
                  className="nf-img"
                />
              </div>
            </div>
          </section>

          {/* COMMON SYMPTOMS AFTER A CAR ACCIDENT */}
          <section className="nf-stripe">
            <div className="nf-sectionTitle">Common symptoms we see after car accidents</div>
            <p className="nf-sectionSubtitle">
              Everyone&apos;s accident story is different, but a lot of people experience patterns like these:
            </p>

            <div className="nf-cardGrid">
              <div className="nf-card">
                <div className="nf-cardTitle">Neck pain & whiplash</div>
                <div className="nf-cardText">
                  Stiffness turning your head, headaches, or a heavy feeling in the neck and shoulders,
                  sometimes delayed a day or two after the accident.
                </div>
              </div>
              <div className="nf-card">
                <div className="nf-cardTitle">Back & rib discomfort</div>
                <div className="nf-cardText">
                  Achiness or sharp spots around the mid or lower back from seatbelts, bracing, or impact forces.
                </div>
              </div>
              <div className="nf-card">
                <div className="nf-cardTitle">Shoulder, hip, or knee pain</div>
                <div className="nf-cardText">
                  Irritated joints and muscles from seatbelt tension, twisting, or impact on the dashboard or door.
                </div>
              </div>
              <div className="nf-card">
                <div className="nf-cardTitle">Headaches & fatigue</div>
                <div className="nf-cardText">
                  Headaches, muscle tension, and feeling more tired than usual while your body and nervous system recover.
                </div>
              </div>
            </div>
          </section>

          {/* HOW NO-FAULT PT WORKS HERE */}
          <section className="nf-stripe">
            <div className="nf-flexRow">
              <div className="nf-flexCol">
                <img
                  src="/content/no-fault-pt/nofault_evaluation.png"
                  alt="Physical therapist performing gentle evaluation after accident"
                  className="nf-img"
                />
              </div>

              <div className="nf-flexCol">
                <div className="nf-sectionTitle">
                  How a no-fault physical therapy plan usually works
                </div>
                <p className="nf-sectionSubtitle">
                  We focus on your recovery and comfort, while helping you organize the details you&apos;ll need
                  for your insurer, doctor, or attorney. We don&apos;t make legal decisions or guarantee coverage—
                  but we do aim to keep your care as clear and organized as possible.
                </p>

                <div className="nf-timeline">
                  <div className="nf-step">
                    <div className="nf-stepNumber">1</div>
                    <div className="nf-stepBody">
                      <strong>Paperwork & basic details</strong>
                      We collect the essentials: claim number (if you have one), date of accident, referring provider,
                      and your contact info so notes can be shared appropriately.
                    </div>
                  </div>

                  <div className="nf-step">
                    <div className="nf-stepNumber">2</div>
                    <div className="nf-stepBody">
                      <strong>Evaluation & movement check</strong>
                      A physical therapist listens to your story, checks motion, strength, and comfort levels, and helps
                      identify which areas should be prioritized.
                    </div>
                  </div>

                  <div className="nf-step">
                    <div className="nf-stepNumber">3</div>
                    <div className="nf-stepBody">
                      <strong>Plan built around your daily life</strong>
                      We design a plan that fits your pain levels, work demands, family responsibilities, and what your
                      provider has recommended.
                    </div>
                  </div>

                  <div className="nf-step">
                    <div className="nf-stepNumber">4</div>
                    <div className="nf-stepBody">
                      <strong>Ongoing communication</strong>
                      We can send progress notes to your doctor and, when appropriate, coordinate documentation that
                      your insurer or attorney may request.
                    </div>
                  </div>
                </div>

                <div className="nf-ctaRow" style={{ marginTop: "16px" }}>
                  <button
                    className="nf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a no-fault evaluation →
                  </button>
                  <button
                    className="nf-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Learn about accepted insurances
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS YOUR BODY (NOT JUST PAPERWORK) */}
          <section className="nf-stripe">
            <div className="nf-flexRow">
              <div className="nf-flexCol">
                <div className="nf-sectionTitle">
                  How physical therapy helps after an accident
                </div>
                <p className="nf-sectionSubtitle">
                  We can&apos;t erase the accident—but we can help your body move forward. No-fault PT focuses on
                  calming irritated tissues, restoring motion, and rebuilding confidence in day-to-day activities.
                </p>

                <div className="nf-twoColGrid">
                  <div className="nf-pillBox">
                    <div className="nf-pillTitle">Reduce pain & stiffness</div>
                    <div className="nf-pillText">
                      Gentle hands-on treatment, movement, and positioning to ease muscle guarding and joint irritation.
                    </div>
                  </div>
                  <div className="nf-pillBox">
                    <div className="nf-pillTitle">Restore motion</div>
                    <div className="nf-pillText">
                      Gradual stretches and mobility work for the neck, back, shoulders, or other areas affected.
                    </div>
                  </div>
                  <div className="nf-pillBox">
                    <div className="nf-pillTitle">Rebuild strength</div>
                    <div className="nf-pillText">
                      Targeted strengthening so you can lift, carry, and move without feeling like everything is fragile.
                    </div>
                  </div>
                  <div className="nf-pillBox">
                    <div className="nf-pillTitle">Support daily tasks</div>
                    <div className="nf-pillText">
                      Strategies for driving, working, caring for kids, and getting through the day with fewer flare-ups.
                    </div>
                  </div>
                </div>

                <div className="nf-ctaRow" style={{ marginTop: "18px" }}>
                  <button
                    className="nf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a visit →
                  </button>
                </div>
              </div>

              <div className="nf-flexCol">
                <img
                  src="/content/no-fault-pt/nofault_treatment.png"
                  alt="Therapist guiding gentle exercises after auto injury"
                  className="nf-img"
                />
              </div>
            </div>
          </section>

          {/* FAQ / QUICK CLARITY */}
          <section className="nf-stripe">
            <div className="nf-sectionTitle">Quick answers to common no-fault questions</div>
            <p className="nf-sectionSubtitle">
              These are general ideas, not legal or insurance advice. Your exact situation depends on your policy
              and local laws, so always confirm details with your insurer, attorney, or healthcare provider.
            </p>

            <div className="nf-twoColGrid">
              <div className="nf-pillBox">
                <div className="nf-pillTitle">Do I need a referral?</div>
                <div className="nf-pillText">
                  Some insurers require a prescription or referral for physical therapy under no-fault. If you&apos;re
                  unsure, we can tell you what information we typically see and encourage you to confirm with your carrier.
                </div>
              </div>
              <div className="nf-pillBox">
                <div className="nf-pillTitle">Can I start PT even if my case is still open?</div>
                <div className="nf-pillText">
                  In many cases, yes. No-fault is designed so you don&apos;t have to wait for fault decisions to seek care.
                  We encourage you to confirm specifics with your adjuster or attorney.
                </div>
              </div>
              <div className="nf-pillBox">
                <div className="nf-pillTitle">What will I owe?</div>
                <div className="nf-pillText">
                  Financial responsibility depends on your policy, coverage limits, and approvals. Our front desk can
                  review what we typically see, and we always recommend speaking directly with your insurer about benefits.
                </div>
              </div>
              <div className="nf-pillBox">
                <div className="nf-pillTitle">Can you share notes with my doctor or attorney?</div>
                <div className="nf-pillText">
                  With your permission and any required paperwork, we can send treatment notes or summaries to your
                  referring provider and, when appropriate, to your legal team.
                </div>
              </div>
            </div>

            <div className="nf-ctaRow" style={{ marginTop: "18px" }}>
              <button
                className="nf-btnPrimary"
                onClick={() => navigate("/contact")}
              >
                Message us about your case →
              </button>
              <button
                className="nf-btnSecondary"
                onClick={() => navigate("/appointments")}
              >
                Schedule an evaluation
              </button>
            </div>
          </section>

          {/* BANNER */}
          <section className="nf-stripe">
            <div className="nf-banner">
              <img
                src="/content/no-fault-pt/nofault_banner.png"
                alt="Bright, calm physical therapy clinic environment"
              />
              <div className="nf-bannerOverlay">
                <div className="nf-bannerText">
                  Recovering from a car accident can feel overwhelming. Physical therapy gives you a calm,
                  one-on-one place to focus on how your body feels today—while the rest of the process continues
                  in the background.
                </div>
                <div className="nf-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a no-fault visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* DISCLAIMER / SAFETY NOTE */}
          <section className="nf-stripe">
            <div className="nf-bottomStrip">
              <div className="nf-bottomText">
                This page is for general information only and is not legal advice, insurance advice, or a guarantee
                of coverage. <strong>Always confirm details with your insurance company, attorney, or medical provider.</strong>{" "}
                If you have red-flag symptoms—like chest pain, trouble breathing, new weakness, confusion, or severe pain—
                seek emergency medical care first. Physical therapy can then help support your recovery once serious
                conditions are ruled out.
              </div>
              <div className="nf-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a no-fault PT visit
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Contact our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default NoFaultPT;
